const AbstractResourcesView = require("common/AbstractResourcesView");
const Utils = require("common/Utils");

/**
 * Display a list of Network Places
 *
 * @class
 * @extends {AbstractResourcesView}
 * @param launcher {function} - callback
 */
function NetworkPlacesListView(launcher) {
    AbstractResourcesView.call(this, launcher);

    const contentClass = "vfs";
    this.getContent().attr("data-nav-icon-class", contentClass);

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "NetworkPlacesList";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getWeight = function() {
        return 10;
    };

    const super_headerConf = this.getHeaderConfiguration;
    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return $.extend(super_headerConf(), {
            title : $.t("common::resources.filter.folders"),
            i18n : "common::resources.filter.folders",
            contentClass : contentClass
        });
    };
}

Utils.inherits(NetworkPlacesListView, AbstractResourcesView);

module.exports = NetworkPlacesListView;


//////////////////
// WEBPACK FOOTER
// ./network_places/NetworkPlacesListView.js
// module id = 109
// module chunks = 0